module.exports = __webpack_public_path__ + "static/media/icon_black.83fd782c.svg";